// Build and download a CSV in the browser.
// `columns`: [{ header, value: (row) => cell }].

const cell = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;

export const csvText = (columns, rows) =>
  [
    columns.map((c) => cell(c.header)).join(','),
    ...rows.map((r) => columns.map((c) => cell(c.value(r))).join(',')),
  ].join('\n');

export const downloadCsv = (filename, columns, rows) => {
  const blob = new Blob([csvText(columns, rows)], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

// File-name-safe slug for an account or event name.
export const csvSlug = (name) =>
  (name || 'report').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '');
